import { IQueryContextDatasourceColumnState } from 'src/app/services/query-context/models/IQueryContext';
import { ICompiledSQLTokens } from 'src/app/utils/datasource-sql-map/datasource';
import { DatePickerComponent } from '../../components/date-picker/date-picker.component';

export class DatePickerSqlTokensCompiler {
    public static compileTokens(
        columnSQL: string,
        state: IQueryContextDatasourceColumnState
    ): Partial<ICompiledSQLTokens> {
        // console.log({
        //     msg: 'datePickerComponentCompileSQLTokens',
        //     columnSQL: JSON.stringify(columnSQL),
        //     state: JSON.stringify(state),
        // });
        const where: Partial<ICompiledSQLTokens> = (() => {
            if (state.isFilterApplied)
                return {
                    where: [
                        DatePickerComponent.toFilterSQL(columnSQL, state.value),
                    ],
                };
            return {};
        })();

        const split_group: Partial<ICompiledSQLTokens> = (() => {
            if (state.isSplitApplied)
                return {
                    split_group: [
                        DatePickerComponent.toSplitSQL(columnSQL, state.value),
                    ],
                };
            return {};
        })();
        return { ...where, ...split_group };
    }
}
